import { render } from "./CustomRouteFrequencySelectComponent.vue?vue&type=template&id=4b9a9de6&ts=true"
import script from "./CustomRouteFrequencySelectComponent.vue?vue&type=script&lang=ts"
export * from "./CustomRouteFrequencySelectComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__